// extracted by mini-css-extract-plugin
export var activityContainer = "_n2-0";
export var typingIndicatorContainer = "_n2-1";
export var typingIndicatorDot = "_n2-2";
export var wave = "_n2-3";